import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import * as grupoCargoService from "../../services/grupoCargoService";

/**
 * Autocomplete para seleccion de Grupo de Cargo.
 * Permite buscar por texto (codigo o descripcion).
 */
const GrupoCargoAutocomplete = ({
    value,
    onChange,
    disabled = false,
    label = "Grupo de Cargo",
    required = false,
    soloActivos = true,
    size = "small"
}) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;
        setLoading(true);

        grupoCargoService.getsGrupoCargoViewSearchBasic("", soloActivos ? 2 : 0)
            .then((data) => {
                if (active) {
                    setOptions(data || []);
                    setLoading(false);
                }
            })
            .catch(() => {
                if (active) {
                    setOptions([]);
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [soloActivos]);

    const selectedOption = options.find((opt) => opt.id === value || opt.idGrupoCargo === value) || null;

    return (
        <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            value={selectedOption}
            onChange={(event, newValue) => {
                if (onChange) {
                    onChange(newValue ? (newValue.id || newValue.idGrupoCargo) : 0, newValue);
                }
            }}
            isOptionEqualToValue={(option, val) => (option.id || option.idGrupoCargo) === (val.id || val.idGrupoCargo)}
            getOptionLabel={(option) => option ? `${option.codigo} - ${option.descripcion}` : ""}
            options={options}
            loading={loading}
            disabled={disabled}
            size={size}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    required={required}
                    size={size}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default GrupoCargoAutocomplete;

